const addJavascriptScriptToHead = (src, id) => {
	const scr = document.createElement('script');

	const head = document.head || document.getElementsByTagName('head')[0];
	scr.src = src;
	scr.id = id;
	head.insertBefore(scr, head.firstChild);
};

export default addJavascriptScriptToHead;
